module.exports = __webpack_public_path__ + "static/media/tick.8e2f2483.svg";